import { noop } from '@sail/utils';
import { createContext } from 'react';
export default /*#__PURE__*/ createContext(()=>noop);

//# sourceMappingURL=PerformanceMonitorTrackSelfContext.js.map